import { serverHost } from "variables/serverdata";
import { getAuthToken } from "../../util/helpers";

// ------------------------ INSERT ------------------------
export async function insertNumberTranslation(numberTranslation, details, site_uuid, user_uuid) {
    const token = getAuthToken();

    const res = await fetch(`${serverHost}/create_number_translation`, {
        method: "POST",
        headers: {
            "Content-Type": "application/json",
            Authorization: `Bearer ${token}`
        },
        body: JSON.stringify({ numberTranslation, details, site_uuid, user_uuid }),
    });

    return res.json();
}

// ------------------------ UPDATE ------------------------
export async function updateNumberTranslation(numberTranslation, details, site_uuid, user_uuid) {
    if (!numberTranslation.number_translation_uuid)
        throw new Error("Missing number_translation_uuid");

    const token = getAuthToken();

    const res = await fetch(
        `${serverHost}/update_number_translation/${numberTranslation.number_translation_uuid}`,
        {
            method: "PUT",
            headers: {
                "Content-Type": "application/json",
                Authorization: `Bearer ${token}`,
            },
            body: JSON.stringify({ numberTranslation, details, site_uuid, user_uuid }),
        }
    );

    return res.json();
}

// ------------------------ GET SINGLE ------------------------
export async function getNumberTranslation(number_translation_uuid) {
    const token = getAuthToken();
    const res = await fetch(`${serverHost}/get_number_translation/${number_translation_uuid}`, {
        headers: { Authorization: `Bearer ${token}` },
    });

    if (!res.ok) {
        const errorData = await res.json().catch(() => ({}));
        throw new Error(errorData.error || "Failed to fetch number translation");
    }
    return res.json();
}
